import React from 'react';
import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { getStoredUser } from '../../utils/localStorage';
const MainDashboard = Loadable(lazy(() => import('./mainDashboard')));
const CustomerDashboard = Loadable(lazy(() => import('./customerDashboard')));

function IndexMain() {
  const user = getStoredUser();
  return <>{user?.role === 'Customer' ? <CustomerDashboard /> : <MainDashboard />}</>;
}

export default IndexMain;
